/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetUserWalletsDTO } from '../model/getUserWalletsDTO';
import { SetAutoWalletRequest } from '../model/setAutoWalletRequest';
import { UserWallet } from '../model/userWallet';
import { UserWalletHistoryDTO } from '../model/userWalletHistoryDTO';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class WalletApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Get user wallet history
     * 
     * @param userWalletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserWalletHistory(userWalletId: number, observe?: 'body', reportProgress?: boolean): Observable<UserWalletHistoryDTO>;
    public getUserWalletHistory(userWalletId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UserWalletHistoryDTO>>;
    public getUserWalletHistory(userWalletId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UserWalletHistoryDTO>>;
    public getUserWalletHistory(userWalletId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userWalletId === null || userWalletId === undefined) {
            throw new Error('Required parameter userWalletId was null or undefined when calling getUserWalletHistory.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UserWalletHistoryDTO>('get',`${this.basePath}/wallet/user/history/${encodeURIComponent(String(userWalletId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user wallets
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserWallets(observe?: 'body', reportProgress?: boolean): Observable<Array<UserWallet>>;
    public getUserWallets(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserWallet>>>;
    public getUserWallets(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserWallet>>>;
    public getUserWallets(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserWallet>>('get',`${this.basePath}/wallet/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user wallets by mail
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserWalletsByMail(body?: GetUserWalletsDTO, observe?: 'body', reportProgress?: boolean): Observable<Array<UserWallet>>;
    public getUserWalletsByMail(body?: GetUserWalletsDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserWallet>>>;
    public getUserWalletsByMail(body?: GetUserWalletsDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserWallet>>>;
    public getUserWalletsByMail(body?: GetUserWalletsDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Array<UserWallet>>('post',`${this.basePath}/wallet/user/wallets`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user wallets history
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserWalletsHistory(observe?: 'body', reportProgress?: boolean): Observable<Array<UserWalletHistoryDTO>>;
    public getUserWalletsHistory(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<UserWalletHistoryDTO>>>;
    public getUserWalletsHistory(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<UserWalletHistoryDTO>>>;
    public getUserWalletsHistory(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<UserWalletHistoryDTO>>('get',`${this.basePath}/wallet/user/history`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set active User Wallet
     * 
     * @param userWalletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setActiveUserWallet(userWalletId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setActiveUserWallet(userWalletId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setActiveUserWallet(userWalletId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setActiveUserWallet(userWalletId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userWalletId === null || userWalletId === undefined) {
            throw new Error('Required parameter userWalletId was null or undefined when calling setActiveUserWallet.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('patch',`${this.basePath}/wallet/active/${encodeURIComponent(String(userWalletId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set wallet auto recharge ON
     * 
     * @param userWalletId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setAutoWallet(userWalletId: number, body?: SetAutoWalletRequest, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public setAutoWallet(userWalletId: number, body?: SetAutoWalletRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public setAutoWallet(userWalletId: number, body?: SetAutoWalletRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public setAutoWallet(userWalletId: number, body?: SetAutoWalletRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userWalletId === null || userWalletId === undefined) {
            throw new Error('Required parameter userWalletId was null or undefined when calling setAutoWallet.');
        }


        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('patch',`${this.basePath}/wallet/user/auto-on/${encodeURIComponent(String(userWalletId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Set wallet auto recharge OFF
     * 
     * @param userWalletId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public unsetAutoWallet(userWalletId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public unsetAutoWallet(userWalletId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public unsetAutoWallet(userWalletId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public unsetAutoWallet(userWalletId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userWalletId === null || userWalletId === undefined) {
            throw new Error('Required parameter userWalletId was null or undefined when calling unsetAutoWallet.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('patch',`${this.basePath}/wallet/user/auto-off/${encodeURIComponent(String(userWalletId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
